// 文件与附件：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 文件预览
export const preview = Object.freeze({
  "filePreview.dialog": "文件预览",
  "filePreview.interactionMode": "预览交互模式",
  "filePreview.contentModeHint": "{mode}模式下可使用文件自身的预览功能",
  "filePreview.globalDragHint": "在内容区域按住鼠标可拖动整个预览窗口",
  "filePreview.globalDrag": "全局拖拽",
  "filePreview.close": "关闭文件预览",
  "filePreview.previous": "上一个文件",
  "filePreview.next": "下一个文件",
  "filePreview.loading": "文件加载中...",
  "filePreview.pdfLoading": "PDF 加载中...",
  "filePreview.pdfLoadFailed": "PDF 暂时无法预览，请重试或下载文件",
  "filePreview.retry": "重试",
  "filePreview.downloadFile": "下载文件",
  "filePreview.zoomOutPdf": "缩小 PDF",
  "filePreview.zoomInPdf": "放大 PDF",
  "filePreview.videoLoading": "视频加载中...",
  "filePreview.videoUnsupported": "当前浏览器不支持该视频格式或编码",
  "filePreview.downloadVideo": "下载视频",
  "filePreview.openNewWindow": "新窗口打开",
  "filePreview.loadFailed": "文件加载失败，请关闭后重试",
  "filePreview.dragToMove": "拖动以移动预览窗口",
  "filePreview.videoToolbar": "视频预览工具",
  "filePreview.imageToolbar": "图片预览工具",
  "filePreview.rotateLeft": "向左旋转",
  "filePreview.rotateRight": "向右旋转",
  "filePreview.zoomOutVideo": "缩小视频",
  "filePreview.zoomOutImage": "缩小图片",
  "filePreview.resetVideo": "复位视频",
  "filePreview.resetImage": "复位图片",
  "filePreview.zoomInVideo": "放大视频",
  "filePreview.zoomInImage": "放大图片",
  "filePreview.unknownFile": "未知文件",
  "filePreview.imageMode": "图片操作",
  "filePreview.videoMode": "视频操作",
  "filePreview.documentMode": "文档操作",
  "filePreview.noFile": "暂无可预览文件",
  "filePreview.addressFailed": "文件访问地址获取失败",
});

// 文件库
export const library = Object.freeze({
  "uploadLibrary.associationAll": "全部",
  "uploadLibrary.associationLinked": "已关联",
  "uploadLibrary.associationUnlinked": "未关联",
  "uploadLibrary.allFiles": "全部文件",
  "uploadLibrary.recent": "最近使用",
  "uploadLibrary.ungrouped": "未分组",
  "uploadLibrary.images": "图片",
  "uploadLibrary.videos": "视频",
  "uploadLibrary.documents": "文件",
  "uploadLibrary.previewUnavailable": "当前文件暂无可用预览地址",
  "uploadLibrary.typeNotAllowed": "该文件类型不符合当前上传要求",
  "uploadLibrary.sizeExceeded": "该文件大小超过当前上传限制",
  "uploadLibrary.enterGroupName": "请输入分组名称",
  "uploadLibrary.newGroup": "新建分组",
  "uploadLibrary.groupNameRequired": "分组名称不能为空",
  "uploadLibrary.groupCreated": "分组已创建",
  "uploadLibrary.deleteGroupConfirm":
    "删除分组“{name}”后，组内文件将移到未分组，文件不会被删除。是否继续？",
  "uploadLibrary.deleteGroup": "删除分组",
  "uploadLibrary.groupDeleted": "分组已删除，组内文件已移到未分组",
  "uploadLibrary.chooseFile": "请选择要上传的文件",
  "uploadLibrary.unsupportedType": "{name}：不支持该文件类型",
  "uploadLibrary.maxFileSize": "{name}：文件大小不能超过{size}MB",
  "uploadLibrary.fileUploadFailed": "{name}：上传失败",
  "uploadLibrary.missingFileRecord": "{name}：后端未返回真实文件记录",
  "uploadLibrary.uploadFailed": "上传失败",
  "uploadLibrary.uploadSuccess":
    "成功上传{count}个文件，已切换到全部文件并自动选中",
  "uploadLibrary.uploadFailedCount": "{count}个文件上传失败：{reason}",
  "uploadLibrary.filesMoved": "已将{count}个文件移动到“{name}”",
  "uploadLibrary.deleteFilesConfirm":
    "确认删除选中的{count}个未关联文件？已关联的文件不可删除！",
  "uploadLibrary.deleteFiles": "批量删除文件",
  "uploadLibrary.deleteSummary": "已删除{deleted}个文件，跳过{skipped}个文件",
  "uploadLibrary.refreshAndRetry": "请刷新页面后重试",
  "uploadLibrary.deleteFailedReason": "{message}；{reason}",
  "uploadLibrary.deleteSkippedReason": "{message}。未删除原因：{reason}",
  "uploadLibrary.selectionLimit": "当前上传入口最多选择{count}个文件",
  "uploadLibrary.privateFileNotAllowed":
    "该私有文件无法用于当前公开业务，请选择有权限的文件",
  "uploadLibrary.selectionUnavailable":
    "部分文件无选用权限或已失效，请重新选择本人文件",
  "uploadLibrary.selectFile": "选择文件",
  "uploadLibrary.selectType": "选择{type}",
  "uploadLibrary.filter": "筛选",
  "uploadLibrary.searchAllGroupFiles": "搜索所有分组中的文件名",
  "uploadLibrary.searchFileNames": "全局搜索文件名",
  "uploadLibrary.search": "搜索",
  "uploadLibrary.localBulkUpload": "本地批量上传",
  "uploadLibrary.localUpload": "本地上传",
  "uploadLibrary.maxImagesPerGroup": "每组最多100张",
  "uploadLibrary.selectPage": "全选本页",
  "uploadLibrary.batchManage": "批量管理",
  "uploadLibrary.group": "分组",
  "uploadLibrary.delete": "删除",
  "uploadLibrary.selectedPrefix": "已选择",
  "uploadLibrary.selectedNoticeTail": "个文件，可确认选择或进行批量管理",
  "uploadLibrary.selectedFilesTail": "个文件",
  "uploadLibrary.selectFilesHint": "请勾选文件，选中后可确认选择或进行批量管理",
  "uploadLibrary.clearSelection": "清空选择",
  "uploadLibrary.deletionProgress":
    "正在处理 {processed}/{total}，已删除 {deleted}，跳过 {skipped}",
  "uploadLibrary.selectNamedFile": "选择文件：{name}",
  "uploadLibrary.previewImage": "预览图片",
  "uploadLibrary.previewVideo": "预览视频",
  "uploadLibrary.previewFile": "预览文件",
  "uploadLibrary.preview": "预览",
  "uploadLibrary.noRecentFilesPc": "暂无最近使用文件，请先新建或选择分组",
  "uploadLibrary.noRecentFilesMobile":
    "暂无最近使用文件，可到全部文件中选择或上传",
  "uploadLibrary.noMatchingFiles": "暂无符合条件的文件",
  "uploadLibrary.noFiles": "暂无文件",
  "uploadLibrary.batchGroup": "批量分组",
  "uploadLibrary.selectTargetGroupTail": "个文件，请选择目标分组",
  "uploadLibrary.searchGroups": "搜索分组名称",
  "uploadLibrary.targetGroup": "目标分组",
  "uploadLibrary.noMatchingGroups": "没有匹配的分组，可修改关键词或新建分组",
  "uploadLibrary.noGroups": "暂无分组，点击上方新建分组",
  "uploadLibrary.groupChangeImmediate": "分组变更保存后会立即生效。",
  "uploadLibrary.cancel": "取消",
  "uploadLibrary.confirm": "确定",
  "uploadLibrary.confirmSelection": "确认选择",
  "uploadLibrary.confirmSelectionCount": "确认选择（{count}）",
  "uploadLibrary.filePagination": "文件分页",
  "uploadLibrary.totalFiles": "共 {count} 条",
  "uploadLibrary.previousPage": "上一页",
  "uploadLibrary.nextPage": "下一页",
  "uploadLibrary.filterFiles": "筛选文件",
  "uploadLibrary.fileGroups": "文件分组",
  "uploadLibrary.deleteNamedGroup": "删除分组：{name}",
  "uploadLibrary.associationStatus": "关联状态",
  "uploadLibrary.reset": "重置",
  "uploadLibrary.selectFilePrompt": "请选择文件",
});

// 缩略图
export const thumbnail = Object.freeze({
  "uploadThumbnail.pdfCover": "PDF 第一页封面",
  "uploadThumbnail.textSummary": "文件内容摘要",
  "uploadThumbnail.loading": "封面加载中",
  "uploadThumbnail.unavailable": "暂无法显示封面",
  "uploadThumbnail.formatCover": "格式封面",
  "uploadThumbnail.firstPage": "第 1 页",
  "uploadThumbnail.summary": "内容摘要",
  "uploadThumbnail.videoCover": "视频封面",
  "uploadThumbnail.videoFailed": "无法生成视频封面",
  "uploadThumbnail.videoLoading": "正在加载视频封面",
  "uploadThumbnail.groupName": "分组名称",
  "uploadThumbnail.deleteCount": "删除 {count} 个文件？",
  "uploadThumbnail.irreversible": "删除后无法恢复。",
  "uploadThumbnail.skipCount": "另 {count} 个已关联或状态未知的文件将跳过。",
});

export const attachmentUi = Object.freeze({
  "attachmentUi.maxFiles": "最多只能上传{count}个文件",
  "attachmentUi.fileSizeLimit": "{name} 超过大小限制（最大{size}MB）",
  "attachmentUi.unsupportedFile": "不支持的文件类型：{name}",
  "attachmentUi.remainingFiles":
    "最多只能上传{count}个文件，还可上传{remaining}个",
  "attachmentUi.fileRejectionReason": "驳回原因：{reason}",
  "attachmentUi.originalTemplateHint": "上传合同原始模板",
  "attachmentUi.singleStampedHint": "上传单方盖章版本",
  "attachmentUi.doubleStampedHint": "上传双方盖章版本",
  "attachmentUi.tradeContractFiles": "交易合同文件",
  "attachmentUi.piFiles": "PI文件",
  "attachmentUi.ciFiles": "CI文件",
  "attachmentUi.templateContractFiles": "模板合同文件",
  "attachmentUi.singleStampedFiles": "单章合同文件",
  "attachmentUi.doubleStampedFiles": "双章合同文件",
  "attachmentUi.viewNamedFile": "查看{name}",
  "attachmentUi.uploadNamedFile": "上传{name}",
  "attachmentUi.deleteNamedItem": "删除{name}",
  "attachmentUi.rejectedPrefix": "已驳回：",
  "attachmentUi.documents": "文档列表",
  "attachmentUi.rejectionHint": "已驳回，点击查看驳回原因",
  "attachmentUi.viewReason": "查看原因",
  "attachmentUi.upload": "上传",
  "attachmentUi.stamp": "印章",
  "attachmentUi.noRejectionReason": "暂无驳回原因",
  "attachmentUi.removeAttachment": "移除附件",
  "attachmentUi.fileTooLarge": "{name} 超过10MB，无法上传",
  "attachmentUi.fileUploaded": "{name} 上传成功",
  "attachmentUi.downloadFailed": "{name}下载失败",
});

export const sharedFlowUi = Object.freeze({
  "attachmentUi.uploadFailed": "附件上传失败",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...attachmentUi,
  ...preview,
  ...library,
  ...thumbnail,
});
